import { Alert, Box, Button, Paper, Typography } from "@mui/material";
import { LoadingBox } from "@northpowerdev/np-react-utils";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getWorkOrderOnHoldReasons } from "../../../data/mahiApiConnections";
import { hikoAlert } from "../../../utils/HikoAlert";
import { getInspectionEnabledWorkOrderStatues } from "../../../utils/utilityFunctions";
import { MahiContext } from "../../state/MahiContext";
import IcpInspectionStatusChip from "../../styled/IcpInspectionStatusChip";
import { WorkOrderSetStatusDialog } from "./WorkOrderSetStatusDialog";

// const enabledStatuses = [
//     'On Hold With Contractor',
//     'Scheduled',
//     'Inspections Team',
// ]
const enabledStatuses = getInspectionEnabledWorkOrderStatues()

export default function WorkOrderOnHoldPanel({workOrderNumber, status, scheduledDate, onHoldReason, onStatusChange}) {

    const [showDialog, setShowDialog] = useState(false)
    const [onHoldReasons, setOnHoldReasons] = useState([])
    const [isPageLoading, setPageLoading] = useState(false)
    const [newStatusList, setNewStatusList] = useState([])

    const mahiContext = useContext(MahiContext)

    const handleStatusSave = async (workOrderStatus, theOnHoldReason, theScheduledDate) => {
        console.log('handleStatusSave workOrderStatus, theOnHoldReason, theScheduledDate', workOrderStatus, theOnHoldReason, theScheduledDate)
        const result = await onStatusChange(workOrderStatus, theOnHoldReason, theScheduledDate)
        return result
    }

    const handleChangeStatusClick = () => {
        console.log('handleChangeStatusClick showDialog', showDialog ? 'true' : 'false')
        setShowDialog(true)
    }

    const isStatusChangeEnabled = enabledStatuses.includes(status)

    useEffect(() => {
        let didCancel = false
        const abortController = new AbortController()

        const loadReasons = async (abortSignal) => {
            setPageLoading(true)
            try {
                //
                // On hold reasons are dependent on the status to which yu are changing.
                // We only use On Hold Reason when we're changing to On Hold With Contractor, so we always pass that
                // status to the API.
                //
                const reasonsResponse = await getWorkOrderOnHoldReasons(mahiContext, 'On Hold With Contractor', abortSignal)
                if (!didCancel) {
                    setOnHoldReasons(reasonsResponse.onHoldReasons)
                }
            } catch {
                hikoAlert('No work order found', 'We could not find details for your work order')
            } finally {
                if (!didCancel) {
                    setPageLoading(false)
                }
            }
        }

        if (status) {
            // const theNewStatusList = enabledStatuses.filter(es => es !== status) // All enabled statuses except the current status
            const theNewStatusList = enabledStatuses.filter(es => es) // All enabled statuses 
            setNewStatusList(theNewStatusList)
            loadReasons(abortController.signal)
        }

        return (() => {didCancel = true})
    }, [status, mahiContext])

    return (
        <Paper sx={{p:2}}>
            <Typography variant="h5" color="secondary">Hold / Un-Hold or Schedule</Typography>
            <LoadingBox loading={!status}>
                <Box>
                    <Typography variant="body1" component="span">Your work order status is </Typography>
                    <IcpInspectionStatusChip sx={{my:1}} status={status} />
                </Box>
                <Typography variant="body1" paragraph>
                {
                    isStatusChangeEnabled
                    &&
                    <span>You can change status to <strong>{newStatusList.join(', ')}</strong>.</span>
                }
                </Typography>
                <Button variant="outlined" onClick={handleChangeStatusClick} disabled={!isStatusChangeEnabled}>Change Status</Button>
                {
                    !isStatusChangeEnabled
                    &&
                    <Alert sx={{my:1}} severity="info">Status change is only allowed from statuses {enabledStatuses.join(', ')}.</Alert>
                }
            </LoadingBox>
            <LoadingBox loading={isPageLoading}>
                <WorkOrderSetStatusDialog
                    workOrderNumber={workOrderNumber}
                    currentStatus={status}
                    newStatusList={newStatusList}
                    currentScheduledDate={scheduledDate}
                    currentOnHoldReason={onHoldReason}
                    open={showDialog}
                    onClose={() => setShowDialog(false)}
                    onSave={handleStatusSave}
                    onHoldReasonList={onHoldReasons}
                />
            </LoadingBox>
            {/* <DebugBox sx={{mt: 2}} title="fetchedOnHoldReasons" stringify>{fetchedOnHoldReasons}</DebugBox> */}
        </Paper>


    )
}